import axios from '@/api/config';
const scheduleSetting = {
  addScheduleSetting(data) {
    return axios.post(`${process.env.BASE_URL}/scheduleSetting/addScheduleSetting`, data);
  },
  getScheduleSetting(data) {
    return axios.get(`${process.env.BASE_URL}/scheduleSetting/getScheduleSetting`, { params: data });
  },
  updateScheduleSetting(data) {
    return axios.put(`${process.env.BASE_URL}/scheduleSetting/updateScheduleSetting`, data);
  },
  getPlanNameByClassInfoId(data) {
    return axios.get(`${process.env.BASE_URL}/scheduleSetting/getPlanNameByClassInfoId`, { params: data });
  },
  getClassInfoList(data) {
    return axios.post(`${process.env.BASE_URL}/classInfo/pageList`, data);
  },
  batchCopyCourseByClassInfo(data) {
    return axios.post(`${process.env.BASE_URL}/scheduleInfo/batchCopyCourseByClassInfo`, data);
  },
}
export default scheduleSetting



// WEBPACK FOOTER //
// ./src/api/scheduleSetting.js